import { EmployeeFormValues } from '../components/add-employees-step/employee-drawer/employee-form';

// Helpers to create the address and destination objects for the API from the form data
export const createAddressObject = (formData: EmployeeFormValues) => {
  if (!formData.addressLine1 || !formData.townCity || !formData.postcode) {
    return undefined;
  }
  return {
    line1: formData.addressLine1,
    line2: formData.addressLine2 || undefined,
    postTown: formData.townCity,
    postCode: formData.postcode,
    countrySubDivision: formData.countyDistrict || undefined,
  };
};

export const createDestinationObject = (formData: EmployeeFormValues) => {
  return {
    type: formData.iban ? 'IBAN' : 'SCAN',
    currency: formData.currency,
    iban: formData.iban ?? '',
    accountNumber: formData.accountNumber ?? '',
    sortCode: formData.sortCode ?? '',
  };
};
